import { Commodity } from '../../models/commodity';
import { CommodityQuery } from '../../models/commodity-query';
import { createSelector } from '@ngrx/store';

export interface CommodityTableState {
    query: CommodityQuery;
    page: Commodity[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    selection: string[];
    deleting: string[];
}

export const selectCommodityTableState = (state: any) => state.commodityTable;

export const selectCommodityTableQuery = createSelector(selectCommodityTableState,
    (state: CommodityTableState) => state.query);

export const selectCommodityTablePage = createSelector(selectCommodityTableState,
    (state: CommodityTableState) => state.page);

export const selectCommodityTableBusy = createSelector(selectCommodityTableState,
    (state: CommodityTableState) => state.busy);

export const selectCommodityTableCount = createSelector(selectCommodityTableState,
    (state: CommodityTableState) => state.totalCount);

export const selectCommodityTableSelection = createSelector(selectCommodityTableState,
    (state: CommodityTableState) => state.selection);

export const selectCommodityTableError = createSelector(selectCommodityTableState,
    (state: CommodityTableState) => state.error);

export const selectCommodityTableDeleting = createSelector(selectCommodityTableState,
    (state: CommodityTableState) => state.deleting);
